import { VEGA_LITE_CHART_KEYS } from '../../../../constants/aiAnalytics';
import { CHART_PADDING_ALLOWANCE, MIN_CATEGORY_HEIGHT, MIN_CATEGORY_WIDTH } from '../aiAnalyticsConstants';

const DISCRETE_TYPES = new Set(['nominal', 'ordinal']);

export function hasChartKeys(spec) {
  return Boolean(spec) && VEGA_LITE_CHART_KEYS.some(key => key in spec);
}

export function parseSpecSafely(spec) {
  if (!spec) {
    return null;
  }

  try {
    return typeof spec === 'string' ? JSON.parse(spec) : { ...spec };
  } catch (_) {
    return null;
  }
}

export function readFieldValue(row, fieldPath) {
  if (!row || !fieldPath) {
    return undefined;
  }

  return fieldPath.split('.').reduce((currentValue, pathPart) => {
    if (currentValue === null || currentValue === undefined) {
      return currentValue;
    }
    return currentValue[pathPart];
  }, row);
}

export function isDiscreteEncoding(channel) {
  return Boolean(channel?.field && DISCRETE_TYPES.has(channel.type));
}

export function getDistinctFieldCount(data, fieldPath) {
  if (!Array.isArray(data) || !data.length || !fieldPath) {
    return 0;
  }

  const distinctValues = new Set();
  data.forEach(row => {
    const value = readFieldValue(row, fieldPath);
    if (value !== null && value !== undefined) {
      distinctValues.add(value);
    }
  });

  return distinctValues.size;
}

export function getScrollableDimensions(spec, data) {
  const encoding = spec?.encoding || {};
  const discreteXCount = isDiscreteEncoding(encoding.x) ? getDistinctFieldCount(data, encoding.x.field) : 0;
  const discreteYCount = isDiscreteEncoding(encoding.y) ? getDistinctFieldCount(data, encoding.y.field) : 0;

  return {
    hasDiscreteX: discreteXCount > 0,
    hasDiscreteY: discreteYCount > 0,
    minWidth: discreteXCount > 0 ? discreteXCount * MIN_CATEGORY_WIDTH + CHART_PADDING_ALLOWANCE : 0,
    minHeight: discreteYCount > 0 ? discreteYCount * MIN_CATEGORY_HEIGHT + CHART_PADDING_ALLOWANCE : 0
  };
}

export function withResponsiveAutosize(spec, autosizeType) {
  return {
    ...spec,
    autosize: {
      contains: 'padding',
      ...(typeof spec?.autosize === 'object' ? spec.autosize : {}),
      type: autosizeType,
      resize: true
    }
  };
}

export function hasEmbeddedDataValues(spec) {
  return Boolean(spec?.data?.values?.length);
}
